const runWhenIdle = function (callback, timeout) {
  if (typeof window.requestIdleCallback === "function") {
    window.requestIdleCallback(callback, { timeout: timeout || 2000 });
    return;
  }

  window.setTimeout(callback, 1);
};

const runAfterLoad = function (callback) {
  if (document.readyState === "complete") {
    callback();
    return;
  }

  window.addEventListener("load", callback, { once: true });
};

if ("serviceWorker" in navigator) {
  runAfterLoad(function () {
    runWhenIdle(function () {
      navigator.serviceWorker.register("/etc.clientlibs/barcelo/clientlibs/clientlib-serviceworker.min.js").catch(function (err) {
        console.error(err);
      });
    }, 3000);
  });
}

bcl.preInit.push(function () {
  bcl.u.docReady(function () {
    bcl.u.utag.enableListener("profile");
    bcl.contextHub.callWhenReady(function () {
      const profile = bcl.contextHub.get("profile");
      if (profile) {
        const city = bcl.contextHub.getItem(profile, "city"),
          countryCode = bcl.contextHub.getItem(profile, "country_code"),
          internalIP = bcl.contextHub.getItem(profile, "internalIP"),
          clientIP = profile.clientIp,
          data = {
            // eslint-disable-next-line camelcase
            user_country_name: countryCode && countryCode.toLowerCase(),
            // eslint-disable-next-line camelcase
            user_city_name: city && city.toLowerCase(),
            // eslint-disable-next-line camelcase
            user_zipcode: bcl.contextHub.getItem(profile, "zip"),
            // eslint-disable-next-line camelcase
            user_latitude: bcl.contextHub.getItem(profile, "lat"),
            // eslint-disable-next-line camelcase
            user_longitude: bcl.contextHub.getItem(profile, "long"),
            // eslint-disable-next-line camelcase
            user_internal: internalIP ? "1" : "0",
            // eslint-disable-next-line camelcase
            user_IP: clientIP || "",
          };
        bcl.u.utag.addOnLoad(data);
      }
      bcl.u.utag.removeListener("profile");
    }, "profile");

    bcl.u.utag.props.lastReady = true;
    bcl.u.utag.init();
  }, true);
});

bcl.u.load = true;
document.addEventListener("bcl-base-components-loaded", bcl.u.preInit, true);

runAfterLoad(function () {
  runWhenIdle(function () {
    bcl.contextHub.init();
  }, 2500);
});
